module.exports = __webpack_public_path__ + "824ac9308c1e1bb16bf2e7d85a959d1d.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-princess-1.png
// module id = 495
// module chunks = 0